import { Collapseable } from "components/UI/Collapseable/Collapseable";
import { FC } from "react";

import { IncomingPostbackHeaderForm } from "./IncomingPostbackHeaderForm";
import { IncomingPostbackStepForm } from "./IncomingPostbackStepForm";

interface ApiMethodPanelProps {
    disabled?: boolean;
}

export const IncomingPostbackHeaderPanel: FC<ApiMethodPanelProps> = ({ disabled }) => {
    return (
        <Collapseable
            header={<IncomingPostbackStepForm disabled={disabled} />}
            collapsible={disabled ? "disabled" : "icon"}
            className={disabled ? "bg-neutral-100 opacity-45 p-1" : "bg-neutral-100 p-1"}
        >
            <IncomingPostbackHeaderForm />
        </Collapseable>
    );
};
